module.exports = __webpack_public_path__ + "images/kihnu/android-icon-96x96.png";